import { createRequest } from '@shared/services';

interface GetProductMediaDisplayArgTypes {
    productId: string;
}

export async function getProductMediaDisplay(args: GetProductMediaDisplayArgTypes) {
    const { productId } = args;

    const request = createRequest<ProductMediaDisplayResponse>({
        url: `/product/media/display/${productId}`,
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

interface GetProductMediaSpecArgTypes {
    spec_meta_id: string;
}

export async function getProductMediaSpec(args: GetProductMediaSpecArgTypes) {
    const { spec_meta_id } = args;

    const request = createRequest<ProductMediaSpecResponse>({
        url: `/product/media/spec/${spec_meta_id}`,
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

interface DeleteProductMediaArgTypes {
    id: string;
}

type PutProductMediaOrderArgTypes = Array<{
    id: string;
    order: number;
}>;

export async function putProductMediaOrder(
    product_id: string,
    data: PutProductMediaOrderArgTypes
) {
    const request = createRequest<BasicSuccessResponse>({
        url: `/product/media/display/${product_id}/order`,
        method: 'PUT',
        withAuthorization: true,
        data,
    });

    return request.execute();
}

export async function deleteProductMedia(args: DeleteProductMediaArgTypes) {
    const { id: media_library_id } = args;

    const request = createRequest<BasicSuccessResponse>({
        url: `/product/media/${media_library_id}`,
        method: 'DELETE',
        withAuthorization: true,
    });

    return request.execute();
}
